import React from 'react';
export default function Carousel() { return <div>Image Carousel</div>; }
